
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.09 37V1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('circle',{attrs:{"cx":"6.091","cy":"12","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"10.091","cy":"12","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"14.091","cy":"12","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"6.091","cy":"26","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"10.091","cy":"26","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"14.091","cy":"26","r":"1","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19.09 37V1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    